import React, { Component } from "react";
import MainMenu from "./components/mainMenu";
import SubNavigation from "./components/subNavigation";
import TopBanner from "./components/topBanner";
import AnimatedBackground from "./components/animatedBackground";
import InstagramFeed from "./components/instagramFeed";
import Footer from "./components/footer";

export default class OurHistory extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		document.title = "QwixSkinz || Company History";
	}
	componentWillUnmount() {}

	render() {
		return (
			<React.Fragment>
				<MainMenu />
				<TopBanner
					bannerHeight="short"
					title="Our History"
					images={["history/deanna-suit-sewing-machine.jpg"]}
				/>

				<SubNavigation
					location={this.props.location}
					refs={this.refs}
					navItems={[
						{ title: "About Us", id: "about" },
						{ title: "The Begining", id: "beginning" },
						{ title: "Achievements", id: "achievements" },
						{ title: "Our Future", id: "future" }
					]}
				/>
				<div className="qs-b" ref="about">
					<div className="container block-wrap behind-trees">
						<div className="d-flex flex-row flex-wrap align-items-stretch">
							<div className="col-12 col-md-6 d-flex align-items-center justify-content-center">
								<img src="/images/logo/favicon.svg" />
							</div>
							<div className="col-12 col-md-6 content dark">
								<div className="section-title">
									<h1 className="title">About Us</h1>

									<p className="lead">
										With more than 20 years experience in the race suit
										industry, Qwixskinz founder &amp; CEO Deanna Panting knew we
										could do better.
									</p>
									<p>
										While providing race suits for all levels of high speed
										sports that require constant aerodynamic &amp; fabric
										developments presented a challenge, we knew the team at
										Qwixskinz as well as our expansive research &amp; design
										partners we could call on can keep pushing the boundaries of
										what is possible.
									</p>
									<p>
										The evolution of race suits from the first Olympics Deanna
										produced race suits for at the 1998 Nagano Olympics to the
										recent <b>2018 PeongChang Olympic Games</b> has been
										impressive but we can do more.
									</p>
									<p>
										Newly planned collaborations, scientific &amp; aerodynamic
										developments and expanded possibilities have the next 4
										years to the 2022 Winter Olympic Games truly exciting!
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* The Begingin Section */}
				<div className="qs-b" ref="beginning">
					<div className="container block-wrap behind-mnt1">
						<div className="d-flex flex-row">
							<div className="col content dark">
								<div className="section-title">
									<h1 className="title">The Beginning</h1>
									<div>
										<img
											src="/images/team/Deanna-bw.jpg"
											alt="Deanna Panting CEO Qwixskinz"
											title="Deanna Panting, CEO Qwixskinz"
											className="float-right pr-4 pb-3"
											style={{ maxWidth: "250px" }}
										/>
										<p className="lead">
											Deanna Panting, founder &amp; CEO of Qwixskinz has an
											extensive athletic background with a competitive history
											that includes 8 years of World Cup Skeleton racing on the
											Canadian National team, winning World Cup medals in all
											colours.
										</p>
										<p>
											She combines this knowledge of what an athlete needs from
											a race suit, both physically &amp; psychologically &amp; with a
											clothing design background that includes more than 20+
											years of experience in the race suit industry.
										</p>
										<p>
											To add the third portion of this triple threat in the
											elite race suit business, Deanna has worked for more than
											a decade on the research &amp; extensive testing phases of
											fabrics, race suit designs &amp; seam placement to lessen the
											drag coefficients &amp; giving our customers every aerodynamic
											benefit when they go to the line.
										</p>
										<p>
											As the industry changed, we have evolved into today’s
											Qwixskinz. We have built an impressive team of aerodynamic
											&amp; scientific experts, state of the art fabric developers &amp;
											world leading designers. All of these components
											culminating in a production team that is second to none in
											quality &amp; attention to each important detail.
										</p>
										<p>
											This team allows Qwixskinz to constantly develop, test,
											improve &amp; produce our products to stay one step ahead of
											the competition.
										</p>
										<p>
											Our newly expanded 3D patterning &amp; future 3D scanning for
											our elite &amp; custom race suits allows the perfect fit with
											less steps to get there. The use of the 3D pattern
											development allows us to break away from the rest that are
											still using 2D flat patterns to allow us a superior fit in
											our stock sized race suits as well.
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* Achievements Section */}
				<div className="qs-b" ref="achievements">
					<div className="container block-wrap behind-mnt1">
						<div className="d-flex flex-row">
							<div className="col content dark">
								<div className="section-title">
									<h1 className="title">Achievements</h1>

									<p className="lead">
										To be in the position the Qwixskinz team has, in being with
										every athlete on their best day in sport is an honour we do
										not take lightly. From the first athletes outfitted in the
										1998 Nagano Olympics to our record number of 17 nations
										wearing Qwixskinz race suits under various sponsor labels in
										PeongChang in 2018, we have been proud in every step that
										has become today’s QWIXSKINZ brand.
									</p>
									<p>
										Along the way we have watched athletes win medals of every
										colour while wearing our race suits. In Olympics, World
										Championships &amp; World Cups as well as an endless list of
										personal bests that make up the magic that competitive sport
										is. With our next steps underway in our pursuit to provide
										the BEST race suits available, we have embraced 3D pattern
										technology &amp; future 3D scanning. We look forward to another
										record breaking year!
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* Our Future Section */}
				<div className="qs-b" ref="future">
					<div className="container block-wrap behind-mnt1">
						<div className="d-flex flex-row">
							<div className="col content dark">
								<div className="section-title">
									<h1 className="title">Our Future</h1>

									<p>
										From the 1998 Nagano Olympics that saw the first athletes
										racing in what would evolve into Qwixskinz, to the 2018
										PeongChang Olympics that saw a record 17 nations take to the
										world stage in our race suits, the Qwixskinz team has been
										driven to find new &amp; better options for the racers who want
										to wear a suit that gives them an aerodynamic advantage.
									</p>
									<p>
										We have studied the competitors to see what has been missing
										when it comes to race suit options.
									</p>
									<p>
										Wind tunnel testing with a world leading team in a facility
										that allows us to include environmental (temperature,
										humidity, etc) has provided us with an advantage in our
										development of the best possible race suits.
									</p>
									<p>
										New 3D pattern development now allows us to provide our
										elite athletes with an elite fit with less time &amp; fittings
										than ever before.
									</p>
									<p>
										We are able to take all of this experience &amp; information &amp;
										apply it to all levels of race suits because quality should
										not just be for the pros.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>

				<InstagramFeed />

				<Footer />
				<AnimatedBackground />
			</React.Fragment>
		);
	}
}
